import * as React from "react";
import { Paper } from "@mui/material";

export interface Props {
    children: JSX.Element;
    className?: string;
    topComponent?: JSX.Element;
    sideComponent?: JSX.Element;
    noContainer?: boolean;
    noTopContainer?: boolean;
    noPadding?: boolean;
    sideComponentNoPadding?: boolean;
    sideOverFlowHidden?: boolean;
    sideComponentSide?: "right" | "left";
    style?: React.CSSProperties;
}

// Keep this component as simple as possible. If you need something much more complex, create a new component instead.
export const MainLayout = ({
    children,
    className,
    topComponent,
    sideComponent,
    noContainer,
    noTopContainer,
    noPadding,
    sideComponentNoPadding,
    sideOverFlowHidden,
    sideComponentSide = "right",
    style
}: Props) => {
    return (
        <section id="main-layout" className={className} style={style}>
            {topComponent && (
                <section id="section-top">
                    {noTopContainer ? (
                        topComponent
                    ) : (
                        <Paper className="section-container">
                            {topComponent}
                        </Paper>
                    )}
                </section>
            )}
            <main
                className={`${topComponent ? "mt-3" : ""} ${
                    sideComponentSide === "left"
                        ? "flex-direction-row-reverse"
                        : ""
                }`}
            >
                <section id="section-main">
                    {noContainer ? (
                        children
                    ) : (
                        <Paper
                            className={`section-container ${
                                noPadding ? "p-0" : ""
                            }`}
                        >
                            {children}
                        </Paper>
                    )}
                </section>

                {sideComponent && (
                    <section
                        id="section-side"
                        className={
                            sideComponentSide === "left" ? "mr-3" : "ml-3"
                        }
                    >
                        <Paper
                            className={`section-container ${
                                noPadding || sideComponentNoPadding ? "p-0" : ""
                            } ${sideOverFlowHidden ? "overflow-hidden" : ""}`}
                        >
                            {sideComponent}
                        </Paper>
                    </section>
                )}
            </main>
        </section>
    );
};
